import useInView from '@propertypal/shared/src/hooks/useInView';
import CoOwnershipLogo from '@propertypal/shared/src/resources/images/co-ownership/co-ownership-logo-white.svg?url';
import { trackGaEvent } from '@propertypal/shared/src/services/analytics';
import { Property } from '@propertypal/shared/src/types/property';
import getCoOwnershipText from '@propertypal/shared/src/utils/co-ownership';
import React, { CSSProperties, FunctionComponent, useRef } from 'react';
import { ButtonLink, Container, Content, ContentImage, ContentText, FadedImage } from './CoOwnershipJumbo.style';

interface Props {
  containerStyle?: CSSProperties;
  property: Property;
}

const CoOwnershipJumbo: FunctionComponent<Props> = (props) => {
  const title = getCoOwnershipText(props.property);
  const containerRef = useRef<HTMLDivElement>(null);
  const page = props.property.type === 'property' ? 'PDP' : 'DDP';

  const trackLink = () => {
    trackGaEvent('co_ownership_LDP_ad_click', {
      page,
      location: 'Co-Ownership Ad',
      availability:
        props.property.type === 'development' ? (props.property.partialCoOwnershipOnly ? 'some' : 'all') : undefined,
    });
  };

  useInView(containerRef, {}, () => {
    trackGaEvent('co_ownership_LDP_ad_impression', {
      page,
      availability:
        props.property.type === 'development' ? (props.property.partialCoOwnershipOnly ? 'some' : 'all') : undefined,
    });
  });

  if (!title) {
    return null;
  }

  return (
    <Container style={props.containerStyle} ref={containerRef}>
      <Content>
        <ContentText>
          <img src={CoOwnershipLogo.src} alt="Co-Ownership" />

          <h2>{title}</h2>

          <p>
            Many new housing developments now include properties set aside as affordable housing. To buy one of these
            homes, you must be approved for an affordable housing option, such as Co-Ownership.
          </p>

          <p>
            If you&apos;re interested in this home and are struggling to save enough for a house deposit or secure a
            full mortgage, Co-Ownership might be able to help you.
          </p>

          <ButtonLink href="/co-ownership" onClick={trackLink}>
            Find out more about Co-Ownership
          </ButtonLink>
        </ContentText>

        <ContentImage>
          <FadedImage />
        </ContentImage>
      </Content>
    </Container>
  );
};

export default CoOwnershipJumbo;
